import { render, staticRenderFns } from "./GraphOfStats.vue?vue&type=template&id=3fa223d2&scoped=true"
import script from "./GraphOfStats.vue?vue&type=script&lang=js"
export * from "./GraphOfStats.vue?vue&type=script&lang=js"
import style0 from "./GraphOfStats.vue?vue&type=style&index=0&id=3fa223d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa223d2",
  null
  
)

export default component.exports